import { Component } from 'angular-ts-decorators';

/**
 * Displays the information about data missing.
 *
 * # Example
 * <pre>
 *   <no-data></no-data>
 * </pre>
 */
@Component({
  selector: 'noData',
  template: require('./no-data.html').default,
})
export class NoDataComponent {
  constructor() {
    'ngInject';
  }
}
